module.exports = __webpack_public_path__ + "8a22106419e69e3a0eb45dcd042560ef.jpg";